<script lang="ts" setup>
import { cn } from '@/lib/utils';
import { CalendarHeading, useForwardProps, type CalendarHeadingProps } from 'radix-vue';
import { computed, type HTMLAttributes } from 'vue';

type HeadingSlotProps = {
  headingValue: string;
};

defineSlots<{
  default(props: HeadingSlotProps): any;
}>();

const props = defineProps<CalendarHeadingProps & { class?: HTMLAttributes['class'] }>();
const delegatedProps = computed(() => {
  const { ...delegated } = props;
  delete delegated.class;

  return delegated;
});
const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <CalendarHeading
    v-slot="{ headingValue }: HeadingSlotProps"
    :class="cn('text-sm font-medium', props.class)"
    v-bind="forwardedProps"
  >
    <slot :heading-value="headingValue">
      {{ headingValue }}
    </slot>
  </CalendarHeading>
</template>
